import React from "react";
import { useEffect } from "react";
import { Routes, Route, useLocation  } from "react-router-dom";
import Homepage from "../pages/Home";
import LeadForm from "../pages/LeadForm";


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

const AppRoutes = () => {
  return (
    <>
     <ScrollToTop />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/leadform" element={<LeadForm />} />
      </Routes>
    </>
  );
};

export default AppRoutes;